import { useState, useEffect } from 'react';
import { SummaryTable } from 'src/Components/Organisms';
import Card, { CardContent, CardTitle } from "src/MarketDataComponents/Card";
import Link from 'next/link';
import { format } from './index';

export default function IncomeStatement({incomeStatement, quote}) {

    const [incomeStatementsFormatted, setIncomeStatementsFormatted] = useState(false);
    const [currency, setCurrency] = useState(null);

    useEffect(() => {
        const incomeStatementsFormatted = [];
        let incomeStatementCurrency = null;

        incomeStatement.reverse().forEach((statement) => {
            incomeStatementCurrency = statement.currency;
            incomeStatementsFormatted.push({
                label: statement.yearEnd ? statement.yearEnd.split('-')[0] : '',
                values: {
                    revenue: format(statement.revenue),
                    pretaxIncome: format(statement.incomePreTax),
                    netIncome: format(statement.income),
                    dilutedEPS: format(statement.dilutedEPS, false, true),
                    normalizedDilutedEPS: format(statement.dilutedEPSNormalised, false, true)
                }
            });
        });

        setCurrency(incomeStatementCurrency);
        setIncomeStatementsFormatted(incomeStatementsFormatted);
    },[]);

    return <>{incomeStatementsFormatted ? <Card>
        <h2 className="h4 margin-bottom-0" data-testid="incomeStatementTableHeader">Income statement</h2>
        <CardContent>
            <SummaryTable 
                periods={incomeStatementsFormatted} 
                categories={{
                    revenue: "Revenue",
                    pretaxIncome: "Pretax income",
                    netIncome: "Net income",
                    dilutedEPS: "Diluted EPS",
                    normalizedDilutedEPS: "Normalized diluted EPS"
                }}
            />
            <Link href={`/sub/${quote.marketCode}/financials/income-statement`} data-testid="incomeStatementMoreLink">More</Link>
        </CardContent>
    </Card>: null}</>

}

